import { api } from './client'

export interface OnboardingStatus {
  user_id: string
  role?: string
  company_id?: string | null
  completed: boolean
  step?: string | null
  status?: string | null
  kyc_status?: string | null
  required: {
    basic: string[]
    legal: string[]
    docs: string[]
  }
  details: Record<string, unknown>
}

export interface CompanyPayload {
  name: string
  type?: string
  size?: string
  legal_name?: string
  registration_number?: string
  regulator_id?: string
  country?: string
}

export interface OnboardingProgressPayload {
  role?: string
  business_types?: string[]
  onboarding_step?: string
  company?: CompanyPayload
  submit_for_review?: boolean
  complete?: boolean
  approved?: boolean
}

export const getOnboardingStatus = async (): Promise<OnboardingStatus> => {
  const response = await api.get<OnboardingStatus>('/onboarding/status')
  return response.data
}

export const updateOnboardingProgress = async (
  payload: OnboardingProgressPayload
): Promise<OnboardingStatus> => {
  const response = await api.put<OnboardingStatus>('/onboarding/progress', payload)
  return response.data
}

export const approveOnboarding = async (userId: string): Promise<OnboardingStatus> => {
  const response = await api.post<OnboardingStatus>(`/onboarding/approve/${userId}`)
  return response.data
}

// ---------------------------------------------------------------------------
// 3-question wizard (Day 1 backend, Day 2 frontend).
// Mirrors apps/api/app/schemas/onboarding.py::OnboardingCompletePayload and
// packages/shared-types/src/api.ts::OnboardingCompletePayloadSchema.
// ---------------------------------------------------------------------------

// Re-exports — activity + tier constants live in @/lib/lcopilot/activities
// so they can be imported without pulling the axios client + Supabase runtime
// into unit tests.
import {
  ACTIVITY_PRIORITY,
  sortActivitiesByPriority,
  type BusinessActivity,
  type BusinessTier,
} from '@/lib/lcopilot/activities'

export { ACTIVITY_PRIORITY, sortActivitiesByPriority }
export type { BusinessActivity, BusinessTier }

export interface OnboardingCompletePayload {
  activities: BusinessActivity[]
  country: string // ISO 3166-1 alpha-2, uppercase
  tier: BusinessTier
  company_name?: string
}

export const completeOnboarding = async (
  payload: OnboardingCompletePayload,
): Promise<OnboardingStatus> => {
  const response = await api.post<OnboardingStatus>('/onboarding/complete', payload)
  return response.data
}

